module.exports = __webpack_public_path__ + "img/loginPage_log.b3ca848a.png";